<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let land of bundeslandFilterService?.getSelectedBundesLaenderNamen()" [label]="land">
    <ng-container *ngIf="isAvailableForBundesland()">
      <app-rbb-wassersport-wetter></app-rbb-wassersport-wetter>
    </ng-container>
  </mat-tab>
</mat-tab-group>

<div class="wetter_content_container" *ngIf="!isAvailableForBundesland()">
  <h2>Es liegt kein Wassersportwetter für {{selectedBundesland}} vor</h2>
</div>
